export default __webpack_public_path__ + "efaa9a2a31ca8357f9decca942ac8241.png";